import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { getSuggerimentiNoteRimborso } from '../services/api';

// Stessi valori di MOTIVI_RIMBORSO in backend/models.py
export const MOTIVI_RIMBORSO = [
  'Articolo danneggiato',
  'Reso',
  'Immagine/descrizione diversa dalle attese',
  'Smarrito in spedizione',
  'Articolo non disponibile',
  'Altro',
];

// Il motivo e' completo se scelto e, per "Altro", accompagnato da una nota
export const motivoRimborsoCompleto = ({ motivo_rimborso, note_rimborso }) =>
  !!motivo_rimborso && (motivo_rimborso !== 'Altro' || !!(note_rimborso || '').trim());

function MotivoRimborsoFields({ value, onChange, disabled = false }) {
  const motivo = value.motivo_rimborso || '';
  // Note gia' usate su altri rimborsi, proposte come completamento
  const [suggerimenti, setSuggerimenti] = useState([]);
  useEffect(() => {
    getSuggerimentiNoteRimborso().then((res) => setSuggerimenti(res.data)).catch(() => {});
  }, []);
  return (
    <>
      <Form.Group className="mb-2">
        <Form.Label>Motivo del rimborso</Form.Label>
        <Form.Select
          value={motivo}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, motivo_rimborso: e.target.value })}
        >
          <option value="">Seleziona il motivo...</option>
          {MOTIVI_RIMBORSO.map((m) => <option key={m} value={m}>{m}</option>)}
        </Form.Select>
      </Form.Group>
      <Form.Group>
        <Form.Label>Note{motivo === 'Altro' ? ' (obbligatorie)' : ' (facoltative)'}</Form.Label>
        <Form.Control
          type="text"
          list="suggerimenti-note-rimborso"
          disabled={disabled}
          value={value.note_rimborso || ''}
          onChange={(e) => onChange({ ...value, note_rimborso: e.target.value })}
          placeholder="Scrivi o scegli una nota già usata"
        />
        <datalist id="suggerimenti-note-rimborso">
          {suggerimenti.map((n) => <option key={n} value={n} />)}
        </datalist>
      </Form.Group>
    </>
  );
}

export default MotivoRimborsoFields;
